// kendo
import { Loader } from "@progress/kendo-react-indicators";

export const IFeedbackDetailsStatus = ({ loading, status }) => {
  return (
    <div className="dr-safe-details-status-wrapper">
      <div className="dr-safe-details-status-title">Status</div>
      <div>
        {loading ? (
          <Loader
            type="infinite-spinner"
            className="dr-safe-details-status-loader"
          />
        ) : (
          <div className="dr-safe-details-status-text">{status || "NA"}</div>
        )}
      </div>
    </div>
  );
};
